import React from 'react';
import { Form } from 'react-final-form';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import { LoginProjectConfiguration } from '../../../api';
import { useCurrentProject } from '../../../contexts/settings';
import { useNotifications } from '../../../hooks/useNotifications';
import { usePaths } from '../../../routes/routesHelper';
import { FieldBlock, FieldSwitch, FormFooter } from '../../ui';

type Props = RouteComponentProps & {
  projectId: string;
};

const SocialNetworksForm = ({ history, projectId }: Props): JSX.Element => {
  const { navigationPath } = usePaths();
  const intl = useIntl();
  const { currentProject, currentUpdateFetching, patchCurrentFineProject } =
    useCurrentProject(projectId);
  const { showErrorNotify, showSuccessNotify } = useNotifications();

  const onSubmit = async (values: Partial<LoginProjectConfiguration>) => {
    try {
      await patchCurrentFineProject(values, projectId);
      showSuccessNotify();
    } catch (err) {
      showErrorNotify();
    }
  };

  const backToNavigation = () => history.push({ pathname: navigationPath(projectId) });

  return (
    <div data-test-id="social-jwt-token-form">
      <Form
        onSubmit={onSubmit}
        initialValues={{
          add_social_access_token: currentProject?.add_social_access_token
        }}
        keepDirtyOnReinitialize>
        {({ handleSubmit, pristine }) => {
          return (
            <>
              <>
                <FieldBlock
                  notificationBelow={intl.formatMessage({
                    id: 'social-connection.jwt.notification'
                  })}>
                  <FieldSwitch
                    name="add_social_access_token"
                    caption={intl.formatMessage({ id: 'social-connection.jwt.subtitle' })}
                    label={intl.formatMessage({ id: 'social-connection.jwt.title' })}
                  />
                </FieldBlock>

                <FormFooter
                  disabled={pristine}
                  onSubmit={handleSubmit}
                  onCancel={backToNavigation}
                  fetching={currentUpdateFetching}
                />
              </>
            </>
          );
        }}
      </Form>
    </div>
  );
};

export default withRouter(SocialNetworksForm);
